import moment from "moment";
import * as React from "react";
import { Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import "./configure.scss";
import { toast } from "react-toastify";
interface IConfigurePopupProps {
  isOpen: boolean;
  handleModal: () => void;
  selectedIDs: [];
  request: any;
  setRequest: any;
  handleRequest: (e: any, name: string, legal_due_date: any) => void;
}

const ConfigurePopup: React.FunctionComponent<IConfigurePopupProps> = (
  props: any
) => {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const { request, setRequest } = props;

  const [frequency] = React.useState([
    { label: "One Time", value: "ONE_TIME" },
    { label: "Recurring", value: "RECURRING" },
  ]);

  const [activity_range] = React.useState([
    { label: "Daily", value: "DAILY" },
    { label: "Weekly", value: "WEEKLY" },
    { label: "Monthly", value: "MONTHLY" },
    { label: "Yearly", value: "YEARLY" },
  ]);

  const [days, setDays] = React.useState<[] | any>([]);
  const [daysObject] = React.useState([
    { label: "Sun", value: "1" },
    { label: "Mon", value: "2" },
    { label: "Tue", value: "3" },
    { label: "Wed", value: "4" },
    { label: "Thu", value: "5" },
    { label: "Fri", value: "6" },
    { label: "Sat", value: "7" },
  ]);

  const [months] = React.useState([
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
  ]);

  const [monthString] = React.useState([
    { label: "Jan", value: "1" },
    { label: "Feb", value: "2" },
    { label: "Mar", value: "3" },
    { label: "Apr", value: "4" },
    { label: "May", value: "5" },
    { label: "Jun", value: "6" },
    { label: "Jul", value: "7" },
    { label: "Aug", value: "8" },
    { label: "Sep", value: "9" },
    { label: "Oct", value: "10" },
    { label: "Nov", value: "11" },
    { label: "Dec", value: "12" },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  React.useEffect(() => {
    let array = [];
    for (let i = 0; i < 30; i++) {
      array.push({
        value: i + 1,
        label: i + 1,
      });
    }
    setDays(array);
  }, [props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const tomorrowDate: any = moment().add(1, "days");
  let tomorrow: any = new Date(tomorrowDate);

  const handleCloseModal = () => {
    if (getValue(request, `frequency_type`, "")) {
      props.handleModal();
    } else {
      toast.error("Please select frequency type to continue");
    }
  };
  return (
    <div
      // className="frequency-slidder frequency-slidder--active"
      className={`frequency-slidder  ${
        props.isOpen ? "frequency-slidder--active" : ""
      }`}
    >
      <div className="frequency-modal">
        <div className="frequency-modal-dialog">
          {/* <Modal isOpen={props.isOpen} modalClassName="frequency-modal" className="add-comments-popup-config frequency-modal-dialog"> */}
          <div className="modal-header">
            <div className="d-flex justify-content-between w-100">
              <div className="left-content-holder d-flex align-items-center">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={props.handleModal}
                ></button>
                <h5 className="modal-title">Edit Frequency</h5>
                <div className="page-title-wrapper">
                  <div className="page-title-name">
                    Assigned Task Configuration
                  </div>
                  {/* <div className="checkpoint-name">Checkpoint ID - L00017997</div> */}
                </div>
              </div>

              <div className="right-content-holder d-flex align-items-center">
                <div className="configure-wrapper__one-task">
                  <div className="d-flex justify-content-end">
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--primary my-0"
                      onClick={handleCloseModal}
                    >
                      {"Cancel"}
                    </button>
                    <button
                      className="ascent-button ascent-button--header-buttons ascent-button--secondary my-0"
                      onClick={handleCloseModal}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="config-modal-content">
            <div className="frequency-modal-center-card">
              {/* <div className="configure-wrapper__frequency d-flex align-items-center">
									<img
										src="/images/checkpoint/frequency.svg"
										className="configure-wrapper__frequency-icon img-fluid"
										alt="test"
									/>
									Frequency
								</div> */}

              <div className="configure-wrapper__form">
                {/* form-group cursor-pointer grid mt-2 */}
                <div className="parent-field-wrapper">
                  <div className="input-grid-item child-field-wrapper legal-due-date-wrapper mb-0">
                    <label className="release-date-wrapper__vendor-label frequency-card-label">
                      Legal Due Date
                    </label>
                    {/* <label onClick={(e) => e.preventDefault()}> */}
                    <div className="position-relative">
                      <InputField
                        inputType="DATETYPE-DOB-MODAL"
                        value={getValue(request, `legal_due_date`, "")}
                        className="form-control"
                        onChange={(e: any) => {
                          // setRequest({
                          // 	...request,
                          // 	legal_due_date: e,
                          // 	// owner_due_date: null,
                          // 	// approver_due_date: null,
                          // 	// function_head_due_date: null,
                          // 	// days_buffer: 0,
                          // });
                          props.handleRequest(
                            e,
                            "legal_due_date",
                            getValue(request, `days_buffer`, "")
                          );
                        }}
                        minDate={
                          // getValue(request, `frequency_type`, "") !== "ONE_TIME" &&
                          tomorrow
                        }
                        placeholderText={"Enter Legal Due Date"}
                      />
                      <img
                        src="/images/checkpoint/calender.svg"
                        className="img-fluid form-image form-image--calender-modal"
                      />
                    </div>
                    {/* </label> */}
                  </div>

                  <div className="child-field-wrapper">
                    <label className="frequency-card-label">Frequency</label>
                    <div className="d-flex align-items-center">
                      {frequency.map((item: object, key: number) => {
                        return (
                          <div
                            key={key}
                            className={`configure-wrapper__task cursor-pointer ${
                              getValue(item, `value`, "") ===
                              getValue(request, `frequency_type`, "")
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              setRequest({
                                ...request,
                                frequency_type: getValue(item, `value`, ""),
                              })
                            }
                          >
                            {getValue(item, `label`, "")}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                {getValue(request, `frequency_type`, "") === "RECURRING" && (
                  <div className="configure-wrapper__create-recuring-task form-group">
                    <label className="configure-wrapper__create-label frequency-card-label ms-0">
                      Create New Copies
                    </label>

                    <div className="d-flex align-items-center new-copies-wrapper">
                      {activity_range.map((item: object) => {
                        return (
                          <div
                            onClick={() =>
                              setRequest({
                                ...request,
                                new_activity_range: getValue(item, `value`, ""),
                              })
                            }
                            className={`configure-wrapper__create-time ${
                              getValue(item, `value`, "") ===
                              getValue(request, `new_activity_range`, "")
                                ? "active"
                                : ""
                            }`}
                          >
                            {getValue(item, `label`, "")}
                          </div>
                        );
                      })}
                    </div>

                    <div className="d-flex activity-range-wrapper">
                      {getValue(request, "new_activity_range", "") ===
                        "DAILY" && (
                        <div className="align-items-center activity-range-value-wrapper">
                          <label className="configure-wrapper__create-label frequency-card-label">
                            Every
                          </label>
                          <div className="d-flex align-items-center">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              className="configure-wrapper__form-control form-control m-0"
                              value={days.filter(
                                (item: any) =>
                                  item.value ==
                                  getValue(request, `once_in_every`, "")
                              )}
                              options={days}
                              onChange={(e: object) =>
                                setRequest({
                                  ...request,
                                  once_in_every: getValue(e, `value`, ""),
                                })
                              }
                            />
                            <p className="activity-range-days-value">day(s)</p>
                          </div>
                        </div>
                      )}
                      {getValue(request, "new_activity_range", "") ===
                        "WEEKLY" && (
                        <>
                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              Every
                            </label>
                            <div className="d-flex align-items-center">
                              <InputField
                                inputType="INPUT_REACT_SELECT"
                                options={days}
                                value={days.filter(
                                  (item: any) =>
                                    item.value ==
                                    getValue(request, `once_in_every`, "")
                                )}
                                onChange={(e: object) =>
                                  setRequest({
                                    ...request,
                                    once_in_every: getValue(e, `value`, ""),
                                  })
                                }
                              />
                              <p className="activity-range-days-value">
                                Weeks(s)
                              </p>
                            </div>
                          </div>

                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              On
                            </label>
                            <div className="d-flex align-items-center">
                              <div className="configure-wrapper__form-control">
                                <InputField
                                  inputType="INPUT_REACT_SELECT"
                                  options={daysObject}
                                  value={daysObject.filter(
                                    (item: any) =>
                                      item.value ==
                                      getValue(request, `on_day`, "")
                                  )}
                                  onChange={(e: object) =>
                                    setRequest({
                                      ...request,
                                      on_day: getValue(e, `value`, ""),
                                    })
                                  }
                                />
                              </div>
                              <p className="activity-range-days-value">Day</p>
                            </div>
                          </div>
                        </>
                      )}

                      {getValue(request, "new_activity_range", "") ===
                        "MONTHLY" && (
                        <>
                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              Once In Every
                            </label>
                            <div className="d-flex align-items-center">
                              <InputField
                                inputType="INPUT_REACT_SELECT"
                                options={months}
                                value={months.filter(
                                  (item: any) =>
                                    item.value ==
                                    getValue(request, `once_in_every`, "")
                                )}
                                onChange={(e: object) =>
                                  setRequest({
                                    ...request,
                                    once_in_every: getValue(e, `value`, ""),
                                  })
                                }
                              />

                              <p className="activity-range-days-value">
                                Months(s)
                              </p>
                            </div>
                          </div>

                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              On
                            </label>
                            <div className="d-flex align-items-center">
                              <div className="configure-wrapper__form-control">
                                <InputField
                                  inputType="INPUT_REACT_SELECT"
                                  options={days}
                                  value={days.filter(
                                    (item: any) =>
                                      item.value ==
                                      getValue(request, `on_day`, "")
                                  )}
                                  onChange={(e: object) =>
                                    setRequest({
                                      ...request,
                                      on_day: getValue(e, `value`, ""),
                                    })
                                  }
                                />
                              </div>
                              <p className="activity-range-days-value">Day</p>
                            </div>
                          </div>
                        </>
                      )}

                      {getValue(request, "new_activity_range", "") ===
                        "YEARLY" && (
                        <>
                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              Once In Every
                            </label>
                            <div className="d-flex align-items-center">
                              <InputField
                                inputType="INPUT_REACT_SELECT"
                                options={days}
                                value={days.filter(
                                  (item: any) =>
                                    item.value ==
                                    getValue(request, `once_in_every`, "")
                                )}
                                onChange={(e: object) =>
                                  setRequest({
                                    ...request,
                                    once_in_every: getValue(e, `value`, ""),
                                  })
                                }
                              />
                              <p className="activity-range-days-value">
                                Year(s)
                              </p>
                            </div>
                          </div>

                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              On
                            </label>
                            <div className="d-flex align-items-center">
                              <div className="configure-wrapper__form-control">
                                <InputField
                                  inputType="INPUT_REACT_SELECT"
                                  options={monthString}
                                  value={monthString.filter(
                                    (item: any) =>
                                      item.value ==
                                      getValue(request, `on_month`, "")
                                  )}
                                  onChange={(e: object) =>
                                    setRequest({
                                      ...request,
                                      on_month: getValue(e, `value`, ""),
                                    })
                                  }
                                />
                              </div>
                              <p className="activity-range-days-value">
                                Month(s)
                              </p>
                            </div>
                          </div>

                          <div className="align-items-center activity-range-value-wrapper">
                            <label className="configure-wrapper__create-label frequency-card-label">
                              On
                            </label>
                            <div className="d-flex align-items-center">
                              <InputField
                                inputType="INPUT_REACT_SELECT"
                                options={days}
                                value={days.filter(
                                  (item: any) =>
                                    item.value ==
                                    getValue(request, `on_day`, "")
                                )}
                                onChange={(e: object) =>
                                  setRequest({
                                    ...request,
                                    on_day: getValue(e, `value`, ""),
                                  })
                                }
                              />

                              <p className="activity-range-days-value">Day</p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}

                <div className="configure-wrapper__one-task d-none">
                  <div className="form-group mb-0 mt-3">
                    <div className="d-flex justify-content-end">
                      <button
                        className="ascent-button ascent-button--header-buttons ascent-button--primary"
                        onClick={props.handleModal}
                      >
                        {"Cancel"}
                      </button>
                      <button
                        className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                        onClick={props.handleModal}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </Modal> */}
        </div>
      </div>
    </div>
  );
};

export default ConfigurePopup;
